import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/redditPixel";
import { trackGaPageView } from "../utils/googleAnalytics";

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track a page view when the route changes, if pixels are loaded
    try {
      trackPageView();
      trackGaPageView(location.pathname);
    } catch (e) {
      // ignore
    }
  }, [location.pathname]);

  return null;
}
